var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-component"},[(_vm.showLoading)?_c(_vm.loaderComponent,{tag:"component"}):_c('highcharts',{ref:"highchart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }